export default "__VITE_ASSET__a824172a__"